var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CalendarBlank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 2.25V5.25M8 2.25V5.25M4.25 8.25H20.75M5 3.75H20C20.4142 3.75 20.75 4.08579 20.75 4.5V19.5C20.75 19.9142 20.4142 20.25 20 20.25H5C4.58579 20.25 4.25 19.9142 4.25 19.5V4.5C4.25 4.08579 4.58579 3.75 5 3.75Z",
    stroke: "#AAACAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1550daeefb873aac6ed31e5c26de0c62.svg";
export { ForwardRef as ReactComponent };